import CategoryCard from "./CategoryCard";
import Image1 from "../../assets/categoryGrid/1.jpg";
import Image2 from "../../assets/categoryGrid/2.png";
import Image3 from "../../assets/categoryGrid/3.png";
import Image4 from "../../assets/categoryGrid/4.png";
import Image5 from "../../assets/categoryGrid/5.png";

// Данные категорий
const categories = [
  {
    id: 1,
    image: Image1,
    title: "Уход для лица",
    link: "/catalog?category_id=110",
  },
  {
    id: 2,
    image: Image2,
    title: "Уход для тела",
    link: "/catalog?category_id=168",
  },
  {
    id: 3,
    image: Image3,
    title: "Уход за волосами",
    link: "/catalog?category_id=74",
  },
  {
    id: 4,
    image: Image4,
    title: "Парфюм",
    link: "/catalog?category_id=1",
  },
  {
    id: 5,
    image: Image5,
    title: "Макияж",
    link: "/catalog?category_id=21",
  },
];

function CategoryGrid() {
  return (
    <div className="container mx-auto md:px-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 py-8">
      {categories.map((category) => (
        <CategoryCard
          key={category.id}
          image={category.image}
          title={category.title}
          link={category.link}
        />
      ))}
    </div>
  );
}

export default CategoryGrid;
